import { render, staticRenderFns } from "./toExamine.vue?vue&type=template&id=c3ca1ef8&scoped=true&"
import script from "./toExamine.vue?vue&type=script&lang=js&"
export * from "./toExamine.vue?vue&type=script&lang=js&"
import style0 from "./toExamine.vue?vue&type=style&index=0&id=c3ca1ef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ca1ef8",
  null
  
)

export default component.exports